import { defineAsyncComponent } from 'vue';

/**
 * 위젯 컴포넌트 맵
 */
export const COMPONENTS = {
  TimeSeriesLineWidget: defineAsyncComponent(
    () =>
      import('@/dashboard/features/widgets/timeSeries/widget/components/timeSeriesLine/TimeSeriesLineWidget.vue'),
  ),
  TimeSeriesAreaWidget: defineAsyncComponent(
    () =>
      import('@/dashboard/features/widgets/timeSeries/widget/components/timeSeriesArea/TimeSeriesAreaWidget.vue'),
  ),
  TimeSeriesBarWidget: defineAsyncComponent(
    () =>
      import('@/dashboard/features/widgets/timeSeries/widget/components/timeSeriesBar/TimeSeriesBarWidget.vue'),
  ),
  TimeSeriesStackedAreaWidget: defineAsyncComponent(
    () =>
      import('@/dashboard/features/widgets/timeSeries/widget/components/timeSeriesStackedArea/TimeSeriesStackedAreaWidget.vue'),
  ),
  TimeSeriesStackedBarWidget: defineAsyncComponent(
    () =>
      import('@/dashboard/features/widgets/timeSeries/widget/components/timeSeriesStackedBar/TimeSeriesStackedBarWidget.vue'),
  ),
  GaugeGaugeCircleWidget: defineAsyncComponent(
    () => import('@/dashboard/features/widgets/gauge/widget/components/GaugeWidget.vue'),
  ),
  GaugeGaugeHalfCircleWidget: defineAsyncComponent(
    () => import('@/dashboard/features/widgets/gauge/widget/components/GaugeWidget.vue'),
  ),
  // displayStyle '' (마이그레이션 이전 데이터) 호환을 위해 유지
  ScatterWidget: defineAsyncComponent(
    () => import('@/dashboard/features/widgets/scatter/widget/components/ScatterWidget.vue'),
  ),
  // 기본/Long-Term 디스플레이 스타일은 동일 ScatterWidget을 재사용 (props.displayStyle로 분기)
  ScatterScatterBasicWidget: defineAsyncComponent(
    () => import('@/dashboard/features/widgets/scatter/widget/components/ScatterWidget.vue'),
  ),
  ScatterScatterLongTermWidget: defineAsyncComponent(
    () => import('@/dashboard/features/widgets/scatter/widget/components/ScatterWidget.vue'),
  ),
  TopListSummaryBarWidget: defineAsyncComponent(
    () =>
      import('@/dashboard/features/widgets/topList/widget/components/topListBarWidget/TopListSummaryBarWidget.vue'),
  ),
  // 25.10.30호환성을 위해 유지
  EqualizerWidget: defineAsyncComponent(
    () => import('@/dashboard/features/widgets/equalizer/widget/components/EqualizerWidget.vue'),
  ),
  EqualizerEqualizerEntryWidget: defineAsyncComponent(
    () => import('@/dashboard/features/widgets/equalizer/widget/components/EqualizerWidget.vue'),
  ),
  EqualizerEqualizerGroupWidget: defineAsyncComponent(
    () => import('@/dashboard/features/widgets/equalizer/widget/components/EqualizerWidget.vue'),
  ),
  TreeGridTreeGridWidget: defineAsyncComponent(
    () => import('@/dashboard/features/widgets/treeGrid/widget/components/TreeGridWidgetV2.vue'),
  ),
  ActionViewStyle1Widget: defineAsyncComponent(
    () =>
      import('@/dashboard/features/widgets/actionView/widget/components/actionViewStyle1Widget/ActionViewStyle1Widget.vue'),
  ),
  ActionViewStyle2Widget: defineAsyncComponent(
    () =>
      import('@/dashboard/features/widgets/actionView/widget/components/actionViewStyle2Widget/ActionViewStyle2Widget.vue'),
  ),
  ActionViewStyle3Widget: defineAsyncComponent(
    () =>
      import('@/dashboard/features/widgets/actionView/widget/components/actionViewStyle3Widget/ActionViewStyle3Widget.vue'),
  ),
  OneDayCompareBarWidget: defineAsyncComponent(
    () =>
      import('@/dashboard/features/widgets/oneDayCompare/widget/components/oneDayCompareBarWidget/OneDayCompareBarWidget.vue'),
  ),
  OneDayCompareLineWidget: defineAsyncComponent(
    () =>
      import('@/dashboard/features/widgets/oneDayCompare/widget/components/oneDayCompareLineWidget/OneDayCompareLineWidget.vue'),
  ),
  ScoreboardStyle1Widget: defineAsyncComponent(
    () =>
      import('@/dashboard/features/widgets/scoreboard/widget/style1/components/ScoreboardStyle1Widget.vue'),
  ),
  ScoreboardStyle2Widget: defineAsyncComponent(
    () =>
      import('@/dashboard/features/widgets/scoreboard/widget/style2/components/ScoreboardStyle2Widget.vue'),
  ),
  StackedProportionBarWidget: defineAsyncComponent(
    () =>
      import('@/dashboard/features/widgets/stackedProportionBar/widget/components/StackedProportionBarWidget.vue'),
  ),
  StackedProportionBarSingleStackWidget: defineAsyncComponent(
    () =>
      import('@/dashboard/features/widgets/stackedProportionBar/widget/components/StackedProportionBarWidget.vue'),
  ),
  StackedProportionBarMultiStackWidget: defineAsyncComponent(
    () =>
      import('@/dashboard/features/widgets/stackedProportionBar/widget/components/StackedProportionBarWidget.vue'),
  ),
  PiePieWidget: defineAsyncComponent(
    () => import('@/dashboard/features/widgets/pie/widget/components/PiePieWidget.vue'),
  ),
  StatusHexaWidget: defineAsyncComponent(
    () => import('@/dashboard/features/widgets/statusEvent/widget/components/StatusHexaWidget.vue'),
  ),
  StatusSummaryCardWidget: defineAsyncComponent(
    () =>
      import('@/dashboard/features/widgets/statusSummary/widget/components/statusSummaryCardWidget/StatusSummaryCardWidget.vue'),
  ),
  StatusSummaryPieWidget: defineAsyncComponent(
    () =>
      import('@/dashboard/features/widgets/statusSummary/widget/components/statusSummaryPieWidget/StatusSummaryPieWidget.vue'),
  ),
  MemoWidget: defineAsyncComponent(
    () => import('@/dashboard/features/widgets/memo/widget/MemoWidget.vue'),
  ),
  TextWidget: defineAsyncComponent(
    () => import('@/dashboard/features/widgets/text/widget/TextWidget.vue'),
  ),
  ImageWidget: defineAsyncComponent(
    () => import('@/dashboard/features/widgets/image/widget/ImageWidget.vue'),
  ),
  GroupWidget: defineAsyncComponent(
    () => import('@/dashboard/features/widgets/group/widget/components/GroupWidget.vue'),
  ),
  ExclusiveStyle1Widget: defineAsyncComponent(
    () =>
      import('@/dashboard/features/widgets/exclusive/widget/components/ExclusiveStyle1Widget.vue'),
  ),
  ServiceCardStyle1Widget: defineAsyncComponent(
    () =>
      import('@/dashboard/features/widgets/business/widget/components/BusinessCardStyle1Widget.vue'),
  ),
  ServiceCardStyle2Widget: defineAsyncComponent(
    () =>
      import('@/dashboard/features/widgets/business/widget/components/BusinessCardStyle2Widget.vue'),
  ),
  TopologyTopologyWidget: defineAsyncComponent(
    () => import('@/dashboard/features/widgets/topologyWidget/components/TopologyWidget.vue'),
  ),
  TopologyPointMapWidget: defineAsyncComponent(
    () =>
      import('@/dashboard/features/widgets/topologyWidget/components/topologyPointMapWidget/TopologyPointMapWidget.vue'),
  ),
  ServerServerWidget: defineAsyncComponent(
    () => import('@/dashboard/features/widgets/server/widget/components/ServerWidget.vue'),
  ),
  HeatmapCurrentHeatmapWidget: defineAsyncComponent(
    () =>
      import('@/dashboard/features/widgets/heatmap/widget/components/currentHeatmapWidget/CurrentHeatmapWidget.vue'),
  ),
  ClusterClusterWidget: defineAsyncComponent(
    () => import('@/dashboard/features/widgets/cluster/widget/components/ClusterWidget.vue'),
  ),
  TopListSummaryCardWidget: defineAsyncComponent(
    () =>
      import('@/dashboard/features/widgets/topList/widget/components/topListCardWidget/TopListSummaryCardWidget.vue'),
  ),
  RealtimeCardListWidget: defineAsyncComponent(
    () => import('@/dashboard/features/widgets/alert/widget/components/AlertWidget.vue'),
  ),
  RealtimeScoreboardWidget: defineAsyncComponent(
    () => import('@/dashboard/features/widgets/alert/widget/components/AlertScoreboardWidget.vue'),
  ),
  RealtimeAlertTableWidget: defineAsyncComponent(
    () => import('@/dashboard/features/widgets/alert/widget/components/AlertTableWidget.vue'),
  ),
  RealtimeScoreboardTableWidget: defineAsyncComponent(
    () =>
      import('@/dashboard/features/widgets/alert/widget/components/AlertScoreboardTableWidget.vue'),
  ),
  RealtimePieWidget: defineAsyncComponent(
    () => import('@/dashboard/features/widgets/alert/widget/components/AlertPieWidget.vue'),
  ),
  ByPeriodAlertTableWidget: defineAsyncComponent(
    () => import('@/dashboard/features/widgets/alert/widget/components/AlertTableWidget.vue'),
  ),
  ByPeriodPieWidget: defineAsyncComponent(
    () => import('@/dashboard/features/widgets/alert/widget/components/AlertPieWidget.vue'),
  ),
  ByPeriodLineWidget: defineAsyncComponent(
    () => import('@/dashboard/features/widgets/alert/widget/components/AlertLineWidget.vue'),
  ),
};

/**
 * Vue 앱에 위젯 컴포넌트 등록
 * @param app - Vue 앱 인스턴스
 */
export const installComponent = (app) => {
  Object.keys(COMPONENTS).forEach((key) => {
    app.component(key, COMPONENTS[key]);
  });
};
